import { render, staticRenderFns } from "./TestArchive.vue?vue&type=template&id=336741a2&scoped=true&"
import script from "./TestArchive.vue?vue&type=script&lang=js&"
export * from "./TestArchive.vue?vue&type=script&lang=js&"
import style0 from "./TestArchive.vue?vue&type=style&index=0&id=336741a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336741a2",
  null
  
)

export default component.exports